###
Shamelessly copied from https://github.com/shaunbowe/ngBindHtmlIfSafe/blob/master/ngBindHtmlIfSafe.js
Edit: removed $compile since we don't need dynamic behaviour in model html
###

module.exports = ($compile, $sce) ->
  return {
    link: (scope, element, attrs) ->
      scope.$watch ((scope) ->
        scope.$eval attrs.bindHtmlIfSafe
      ), (value) ->
        sanitizedHtml = null
        try
          sanitizedHtml = $sce.getTrustedHtml(value)
        catch ex
        if sanitizedHtml != null
          element.html sanitizedHtml
        else
          element.text value
        return
      return
  }
